import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';

import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { DashboardPage } from './pages/DashboardPage';
import { CallManagerPage } from './pages/CallManagerPage';
import { CsvUploadsPage } from './pages/CsvUploadsPage';
import { TwilioExporterPage } from './pages/TwilioExporterPage';
import { TwilioCallsPage } from './pages/TwilioCallsPage';
import { TwilioSMSPage } from './pages/TwilioSMSPage';
import { TwilioJobRunsPage } from './pages/TwilioJobRunsPage';
import { PromptGeneratorPage } from './pages/PromptGeneratorPage';
import { SettingsPage } from './pages/SettingsPage';
import { CallSummaryPage } from './pages/CallSummaryPage';
import { AgentsPage } from './pages/AgentsPage';
import { AgentCallSummaryPage } from './pages/AgentCallSummaryPage';
import OutboundCallingPage from './pages/OutboundCallingPage';
import CreateCampaignPage from './pages/CreateCampaignPage';
import CampaignPreviewPage from './pages/CampaignPreviewPage';
import CampaignDetailsPage from './pages/CampaignDetailsPage';
import AllCampaignsPage from './pages/AllCampaignsPage';
import AdminPage from './pages/AdminPage';

function App() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="calls" element={<CallManagerPage />} />
          <Route path="calls/csv-uploads" element={<CsvUploadsPage />} />
          <Route path="aigent/agents" element={<AgentsPage />} />
          <Route path="aigent/campaigns" element={<AllCampaignsPage />} />
          <Route path="aigent/agents/:agentId/call-summary" element={<AgentCallSummaryPage />} />
          <Route path="aigent/call-summary" element={<CallSummaryPage />} />
          <Route path="outbound-calling" element={<OutboundCallingPage />} />
          <Route path="outbound-calling/create" element={<CreateCampaignPage />} />
          <Route path="outbound-calling/preview" element={<CampaignPreviewPage />} />
          <Route path="outbound-calling/campaign/:campaignId" element={<CampaignDetailsPage />} />
          <Route path="twilio" element={<TwilioExporterPage />} />
          <Route path="twilio/calls" element={<TwilioCallsPage />} />
          <Route path="twilio/sms" element={<TwilioSMSPage />} />
          <Route path="twilio/job-runs" element={<TwilioJobRunsPage />} />
          <Route path="prompts" element={<PromptGeneratorPage />} />
          <Route path="admin" element={<AdminPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
      </Routes>
    </Box>
  );
}

export default App;
// Trigger rebuild Fri Oct 10 14:49:43 IST 2025
// Rebuild trigger Fri Oct 10 14:54:10 IST 2025
// Rebuild trigger Fri Oct 10 14:58:09 IST 2025
